export default __webpack_public_path__ + "static/media/bootstrap-utilities.css.c5fa5d50.map";